<template>
  <v-app-bar
    :extended="loadingSystemUpdate"
    extension-height="7"
    :style="minimal ? minimalStyle : defaultStyle"
    flat
    clipped-left
    app
    v-if="!minimal"
  >
    <!-- Solo mostrar botón nav si NO es minimal -->
    <v-app-bar-nav-icon
      v-if="!minimal"
      @click="goToRoute('/home')"
      class="siteLogo align-start"
    >
      <a @click="goToRoute('/home')"></a>
    </v-app-bar-nav-icon>

    <!-- Espaciador: si minimal, ocupa todo el espacio a la izquierda -->
    <v-spacer></v-spacer>

    <notificaciones-menu></notificaciones-menu>
    <usuario-menu></usuario-menu>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ProductoBuscador from "@/components/producto/buscador/producto.buscador.vue";
import UsuarioMenu from "@/components/usuarios/usuario.menu.vue";
import NotificacionesMenu from "@/components/notificaciones/notificaciones.menu.vue";

export default {
  name: "HeaderEmpresa",
  components: {
    ProductoBuscador,
    UsuarioMenu,
    NotificacionesMenu,
  },
  props: {
    minimal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reload_search: 0,
      navBar: [],
      defaultStyle: {
        "border-bottom": "solid rgba(255, 255, 255, 0.12)",
        "box-shadow": "",
      },
      minimalStyle: {
        "border-bottom": "none",
        "background-color": "transparent",
        "box-shadow": "none",
      },
    };
  },
  computed: {
    ...mapState("sucursales", ["configuracion"]),
    ...mapGetters("auth", ["tieneModulo"]),
    ...mapGetters(["loadingSystemUpdate"]),
    ...mapState("sucursales", ["sucursal"]),
    sucursalName() {
      return this.sucursal && this.sucursal.nombre
        ? this.sucursal.nombre.toUpperCase()
        : "Sucursal - default";
    },
  },
  methods: {
    goToRoute(route) {
      if (this.$route.path !== route) {
        this.$router.push(route).catch((e) => {});
      }
    },
  },
  mounted() {
    this.navBar.push(
      {
        id: 0,
        title: "Inicio",
        icon: "mdi-home",
        route: "/home",
      },
      {
        id: 1,
        title: "Productos",
        icon: "mdi-format-list-checks",
        route: "/productos",
      }
    );
    if (localStorage.getItem("arqueoCaja")) {
      this.navBar.push({
        id: 2,
        title: "Ventas",
        icon: "mdi-cart-arrow-right",
        route: "/ventas",
      });
    }
    if (this.tieneModulo('compras')) {
      this.navBar.push({
        id: 11,
        icon: "mdi-store-outline",
        title: "Compras",
        route: "/compras",
      });
    }
  },
};
</script>

<style scoped>
.siteLogo {
  left: 10px;
  background-image: url("../../../../assets/bear-face-icon-2.png"), none;
  background-size: 50px;
}
</style>
